(() => {
  const intervals = new WeakMap();

  function utcOffset(dateTime) {
    const match = dateTime.match(/([+-])(\d{2}):?(\d{2})$/);
    if (!match) return 0;
    return (match[1] === '-' ? -1 : 1) * (match[2] * 3600000 + match[3] * 60000);
  }

  function nextMonthStart(timestamp, offset) {
    const local = new Date(timestamp + offset);
    return Date.UTC(local.getUTCFullYear(), local.getUTCMonth() + 1, 1) - offset;
  }

  function initializeTimer(timer) {
    if (timer.dataset.countdownInitialized === 'true') return;

    const time = timer.querySelector('[data-time]');
    let target = time ? new Date(time.dateTime).getTime() : NaN;
    const section = timer.closest('[data-countdown-timer]');
    if (!section || Number.isNaN(target)) return;

    timer.dataset.countdownInitialized = 'true';

    const monthly = timer.hasAttribute('data-countdown-monthly');
    const offset = monthly ? utcOffset(time.dateTime) : 0;

    const fields = {
      days: timer.querySelector('[data-days]'),
      hours: timer.querySelector('[data-hours]'),
      minutes: timer.querySelector('[data-minutes]'),
      seconds: timer.querySelector('[data-seconds]'),
    };

    function update() {
      if (monthly) {
        while (target <= Date.now()) target = nextMonthStart(target, offset);
      }

      const remaining = Math.max(0, target - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
      };

      Object.entries(fields).forEach(([key, field]) => {
        if (field) field.textContent = String(values[key]).padStart(2, '0');
      });

      section.classList.remove('countdown-timer--loading');
      section.classList.toggle('countdown-timer--complete', remaining === 0);

      if (remaining === 0 && intervals.has(timer)) {
        window.clearInterval(intervals.get(timer));
        intervals.delete(timer);
      }
    }

    update();
    if (target > Date.now()) intervals.set(timer, window.setInterval(update, 1000));
  }

  function initializeCountdowns(root = document) {
    root.querySelectorAll('[data-countdown]').forEach(initializeTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCountdowns(), { once: true });
  } else {
    initializeCountdowns();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCountdowns(event.target));
})();
